export function setItemLocal<T>(name: string, data: T) {
  window.localStorage.setItem(name, JSON.stringify(data))
}

export function getItemLocal<T>(name: string): T | null {
  const item = window.localStorage.getItem(name)
  if (item) {
    return JSON.parse(item)
  }
  return null
}

export function updateItemLocal<T>(name: string, newObj: T) {
  const oldItem = getItemLocal(name)
  if (oldItem) {
    window.localStorage.setItem(name, JSON.stringify({ ...oldItem, ...newObj }))
  }
}

export function removeItemLocal(name: string) {
  window.localStorage.removeItem(name)
}
